import { colFormRef } from './consts';

export default function(editor, opts = {}) {
  const bm = editor.BlockManager;
  const pfx = opts.pfx;
  const style = opts.defaultStyle
    ? `<style>
    .${pfx} {
      padding: 15px
    }
    .${pfx} input[type=text], select, textarea {
        width: 100%;
        padding: 12px;
        border: 1px solid #ccc;
        border-radius: 4px;
        resize: vertical;
      }

    .${pfx} label {
        padding: 12px 12px 12px 0;
        display: inline-block;
      }
  </style>`
    : '';

  if (opts.blocks.indexOf(colFormRef) >= 0) {
    bm.add(colFormRef, {
      label: `
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="32" height="50">
    <path d="M22,5.5 C22,5.2 21.5,5 20.75,5 L3.25,5 C2.5,5 2,5.2 2,5.5 L2,8.5 C2,8.8 2.5,9 3.25,9 L20.75,9 C21.5,9 22,8.8 22,8.5 L22,5.5 Z M21,8 L3,8 L3,6 L21,6 L21,8 Z" fill-rule="nonzero"></path>
    <path d="M22,10.5 C22,10.2 21.5,10 20.75,10 L3.25,10 C2.5,10 2,10.2 2,10.5 L2,13.5 C2,13.8 2.5,14 3.25,14 L20.75,14 C21.5,14 22,13.8 22,13.5 L22,10.5 Z M21,13 L3,13 L3,11 L21,11 L21,13 Z" fill-rule="nonzero"></path>
    <rect x="2" y="15" width="10" height="3"/>
</svg>
      <div class="gjs-block-label">${opts.labelForm}</div>`,
      category: opts.labelColFormCategory,
      content: `
        <form class="form ${pfx} form-horizontal" action="/collection-form/subscriber/items" onsubmit="return subscribe(event)" data-gjs-type="subscriber-form" data-js="subscriber-form">
            <div class="alert alert-danger alert-message" style="display: none"></div>
             <div class="alert alert-success success-message" style="display: none"></div>  
               <div class="form-group">
    <h4>Subscribe to our newsletter</h4><p>Join our subscribers list to get the latest news, updates and special offers delivered directly in your inbox.</p>
        <div class="input-group">
            <input type="email" name="email" class="form-control" placeholder="Enter your email" required>
                <div class="input-group-append">
                    <input type="submit" class="btn btn-primary" value="Subscribe">
                </div>
        </div>
        </form>
        ${style}
      `,
      render: ({ model, className }) => `
      <div class="${className}-label ${className}__drapcode-wrap">
      ${model.get('label')}
      </div>

      <span class="${className}__info">
        <a target="_blank" href="https://academy.drapcode.com/docs/app-builder/forms-component-subscriber-form" draggable="false">
          <i class="${className}__info-fa fa fa-info-circle" style="margin-left: 5px" title="Check how to use ${
        opts.labelForm
      }?"></i>
        </a>
      </span>
    `,
    });
  }
}
